import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import styles from "./NotFound.module.css";

const NotFound = () => {
  const { lang } = useLang();

  return (
    <motion.div
      className={styles.wrapper}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <span className={styles.code}>404</span>
      <h1 className={styles.title}>
        {lang === "en" ? "Page Not Found" : "Η σελίδα δεν βρέθηκε"}
      </h1>
      <p className={styles.desc}>
        {lang === "en"
          ? "The page you're looking for doesn't exist or has been moved."
          : "Η σελίδα που αναζητάτε δεν υπάρχει ή έχει μετακινηθεί."}
      </p>
      <Link to="/" className={styles.backBtn}>
        {lang === "en" ? "← Back to Home" : "← Πίσω στην Αρχική"}
      </Link>
    </motion.div>
  );
};

export default NotFound;
